// ABOUTME: Initializes Readmore.js text truncation on connect.
// ABOUTME: Replaces SJR-based Readmore initialization after description update.

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    new Readmore(this.element.querySelector('.notes-body'), {
      speed: 5,
      collapsedHeight: 58,
      moreLink: '<a style="font-size:10px;margin-bottom:8px;margin-top:-8px;" href="#">[&hellip;]</a>',
      lessLink: '<a></a>'
    })
  }
}
